export function addDaysToNow(days) {
  const numberOfMlSeconds = new Date().getTime()
  const addMlSeconds = days * 24 * 60 * 60 * 1000
  const newDateObj = new Date(numberOfMlSeconds + addMlSeconds)

  return newDateObj
}
